<template>
<div class="uk-container-small uk-align-center">
  <center><img src="../assets/feast_of_lights_flyer.jpg" width="400"/></center>
  <div style="margin-top: 70px;">
    <h2 class="uk-text-center uk-container-small uk-align-center" style="font-weight: bold;">Methods to CONTRIBUTE towards Scholarships, Equipment and Future Expansions for the Department of Music and Fine Arts</h2>
  </div>
  <div class="uk-grid-match uk-child-width-1-2@s" uk-grid style="margin-top: 20px;">
    <div>
      <h3 style="font-weight: bold;">BY APP OR ONLINE</h3>
      <p>
        Zelle <br/>
        ncualumni.cflc@yahoo.com <br/>
        (FOLs2022)<br/><br/>

        CashApp<br/>
        $NCUCFLC (FOLs2022) <br/><br/>

        GoFundMe<br/>
        gofundme.com/ncufeastoflights<br/>
        (FOLs2022)<br/><br/>
      </p>
    </div>
    <div>
      <h3 style="font-weight: bold;">BY MAILED US CHEQUE OR <br/> MONEY ORDER</h3>
      <p>
        NCU Alumni South<br/>
        Florida Chapter<br/>
        3901 Davie Blvd.<br/>
        Fort Lauderdale, FL<br/>
        33312<br/><br/>
      </p>
    </div>
  </div>


      <h2 style="font-weight: bold; color: #033860;" class="uk-heading-bullet">Feast Of Lights Program</h2>
  <br/>
    <div class="uk-child-width-expand@s uk-text-center" uk-grid uk-lightbox="animation: fade">
      <div>
        <div class="uk-animation-toggle">
          <a class="uk-inline uk-animation-shake" href="/FOL_program2.jpg" data-caption="Caption 3">
            <img src="../assets/FOL_program2.jpg" width="1800" height="1200" alt="" class="uk-border-rounded">
          </a>
        </div>
      </div>
      <div>
        <div class="uk-animation-toggle">
          <a class="uk-inline uk-animation-shake" href="/FOL_program3.jpg" data-caption="Caption 3">
            <img src="../assets/FOL_program3.jpg" width="1800" height="1200" alt="" class="uk-border-rounded">
          </a>
        </div>
      </div>
      <div>
        <div class="uk-animation-toggle">
          <a class="uk-inline uk-animation-shake" href="/FOL_program4.jpg" data-caption="Caption 3">
            <img src="../assets/FOL_program4.jpg" width="1800" height="1200" alt="" class="uk-border-rounded">
          </a>
        </div>
      </div>
    </div>

</div>
</template>

<script>
export default {
  name: "FeastOfLight"
}
</script>

<style scoped>

</style>